import React, { memo } from 'react';
import { AddressAdditionalField } from './AddressAdditionalField';
import { AttachmentsAdditionalFields } from './AttachmentsAdditionalFields';
import { CrossTaskDynamicAdditionalFields } from './CrossTaskDynamicAdditionalFields';
import { DateAdditionalFields } from './DateAdditionalFields';
import { LinearScaleAdditionalFields } from './LinearScaleAdditionalFields';
import { MatrixAdditionalFields } from './MatrixAdditionalFields';
import { TaskFieldTypeEnum } from '../../../../admin-console-volunteer-profile-model';
import { DraggableListField } from './DraggableListField';

interface Props {
  type: TaskFieldTypeEnum;
  isForm?: boolean;
}

export const AdditionalFieldTypeFields = memo((props: Props) => {
  switch (props.type) {
    case 'VOLUNTEER_AddressTaskFieldType':
      return <AddressAdditionalField />;
    case 'VOLUNTEER_AttachmentTaskFieldType':
      return <AttachmentsAdditionalFields />;
    case 'VOLUNTEER_CrossTaskDynamicTaskFieldType':
      return <CrossTaskDynamicAdditionalFields />;
    case 'VOLUNTEER_DateTaskFieldType':
      return <DateAdditionalFields isForm={props.isForm} />;
    case 'VOLUNTEER_CheckboxTaskFieldType':
    case 'VOLUNTEER_DropdownTaskFieldType':
    case 'VOLUNTEER_MultipleChoiceTaskFieldType':
    case 'VOLUNTEER_QuizTaskFieldType':
      return <DraggableListField />;
    case 'VOLUNTEER_LinearScaleTaskFieldType':
      return <LinearScaleAdditionalFields />;
    case 'VOLUNTEER_MatrixTaskFieldType':
      return <MatrixAdditionalFields />;
    default:
      return null;
  }
});
